import React from 'react';
import PropTypes from 'prop-types';

import RatingButtonSmall from './components/RatingButtonSmall';

import './styles.css';

const RatingButtonsGroup = props => {
  const { disabled, mark, onChange, positive, negative } = props;

  const goodDealButtonHandler = () => {
    onChange(mark === 'Good' ? 0 : 1);
  };
  const badDealButtonHandler = () => {
    onChange(mark === 'Bad' ? 0 : -1);
  };

  return (
    <div className="rating-buttons-group">
      <div className="rating-buttons-group__button">
        <RatingButtonSmall
          value={Number(positive)}
          icon="like"
          disabled={disabled}
          action={goodDealButtonHandler}
          toggled={mark === 'Good'}
        />
      </div>
      <div className="rating-buttons-group__button">
        <RatingButtonSmall
          value={Number(negative)}
          icon="dislike"
          action={badDealButtonHandler}
          disabled={disabled}
          toggled={mark === 'Bad'}
        />
      </div>
    </div>
  );
};

RatingButtonsGroup.propTypes = {
  mark: PropTypes.oneOf(['Good', 'Bad']),
  positive: PropTypes.number.isRequired,
  negative: PropTypes.number.isRequired,
  disabled: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default RatingButtonsGroup;
